import { commitMutation, graphql } from "react-relay";
import environment from "../Network";
const mutation = graphql`
  mutation AuthTokenMutation($username: String!, $password: String!) {
    tokenAuth(username: $username, password: $password) {
      token
    }
  }
`;

export default (username, password, callback) => {
  const variables = {
    username,
    password,
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response) => {
      callback(response.tokenAuth);
    },
    onError: (err) => console.error(err),
  });
};



// WEBPACK FOOTER //
// ./src/mutations/AuthTokenMutation.js